export default __webpack_public_path__ + "static/media/arrow-right-blue-icon.9e0db0ac.svg";